import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

const getProducts = async (data = {}) => {
  const params = new URLSearchParams();

  if (data.brand) params.append('brand', data.brand);
  if (data.tag) params.append('tags', data.tag);
  if (data.search) params.append('search', data.search);
  if (data.minPrice) params.append('price[gte]', data.minPrice);
  if (data.maxPrice) params.append('price[lte]', data.maxPrice);
  if (data.sort) params.append('sort', data.sort);
  if (data.page) params.append('page', data.page);
  if (data.limit) params.append('limit', data.limit);

  // Build URL manually to avoid encoding pipes in multi-category filters
  let queryString = params.toString();
  if (data.category) {
    const categoryParam = `category=${data.category}`;
    queryString = queryString ? `${queryString}&${categoryParam}` : categoryParam;
  }

  const url = `${base_url}product${queryString ? `?${queryString}` : ''}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

const getSingleProduct = async (id) => {
  const response = await axios.get(`${base_url}product/${id}`);
  return response.data || null;
};

const addToWishlist = async (prodId) => {
  const response = await axios.put(
    `${base_url}product/Wishlist`,
    { prodId },
    config
  );
  return response.data || null;
};

const rateProduct = async (data) => {
  const response = await axios.put(`${base_url}product/rating`, data, config);
  return response.data || null;
};

const getProductCount = async (data = {}) => {
  const params = new URLSearchParams();

  if (data.brand) params.append('brand', data.brand);
  if (data.tag) params.append('tags', data.tag);
  if (data.search) params.append('search', data.search);
  if (data.minPrice) params.append('price[gte]', data.minPrice);
  if (data.maxPrice) params.append('price[lte]', data.maxPrice);

  let queryString = params.toString();
  if (data.category) {
    const categoryParam = `category=${data.category}`;
    queryString = queryString ? `${queryString}&${categoryParam}` : categoryParam;
  }

  const url = `${base_url}product/count${queryString ? `?${queryString}` : ''}`;

  try {
    const response = await axios.get(url);
    return response.data?.count || 0;
  } catch (error) {
    console.error('Error getting product count:', error);
    return 0;
  }
};

const getAllFilterOptions = async () => {
  try {
    const response = await axios.get(`${base_url}product?limit=50000&fields=brand,category,tags`);
    const products = response.data?.products || response.data || [];

    const brands = [...new Set(products.map(p => p.brand).filter(Boolean))];
    const categories = [...new Set(products.map(p => p.category).filter(Boolean))];
    const tags = [...new Set(products.flatMap(p => p.tags || []).filter(Boolean))];

    return { brands, categories, tags };
  } catch (error) {
    console.error('Error fetching filter options:', error);
    return { brands: [], categories: [], tags: [] };
  }
};

export const productSevice = {
  getProducts,
  getProductCount,
  getAllFilterOptions,
  addToWishlist,
  getSingleProduct,
  rateProduct,
};
